// extracted by mini-css-extract-plugin
export var cardLayout = "_67-1";
export var paginationContainer = "_67-0";